import {
    GET_FIELD_INVENTORY_DASHBOARD,
    GET_FIELD_INVENTORY_DASHBOARD_SUCCESS,
    GET_FIELD_INVENTORY_DASHBOARD_FAILURE,
    RESET_FIELD_INVENTORY_DASHBOARD,
} from '../actions';

const initialState = {
    districtDetailsMap: {},
    loadingDistricts: {},
    error: null,
};

const fieldInventoryDashboardReducer = (state = initialState, action) => {
    switch (action.type) {
        case GET_FIELD_INVENTORY_DASHBOARD: {
            const rawDistrictCode = action.payload?.districtCode;
            const districtCodes =
                rawDistrictCode === undefined
                    ? [undefined]
                    : String(rawDistrictCode)
                          .split(',')
                          .map((code) => code.trim())
                          .filter(Boolean);
            return {
                ...state,
                loadingDistricts: {
                    ...state.loadingDistricts,
                    ...districtCodes.reduce(
                        (loading, districtCode) => ({
                            ...loading,
                            [districtCode]: true,
                        }),
                        {}
                    ),
                },
                error: null,
            };
        }
        case GET_FIELD_INVENTORY_DASHBOARD_SUCCESS: {
            const responseArray = Array.isArray(action.payload) ? action.payload : [action.payload];
            const newDistrictDetailsMap = { ...state.districtDetailsMap };
            responseArray.forEach((item) => {
                if (item?.districtCode) {
                    newDistrictDetailsMap[item.districtCode] = item;
                }
            });
            return {
                ...state,
                loadingDistricts: {},
                districtDetailsMap: newDistrictDetailsMap,
                error: null,
            };
        }
        case GET_FIELD_INVENTORY_DASHBOARD_FAILURE: {
            const { error } = action.payload || {};
            return {
                ...state,
                loadingDistricts: {},
                error,
            };
        }
        case RESET_FIELD_INVENTORY_DASHBOARD:
            return initialState;
        default:
            return state;
    }
};

export default fieldInventoryDashboardReducer;